<script setup>
import { cn, } from '@/utils/ShadcnUtil';

import { cardVariants, } from '~/components/ui/card/index';

const props = defineProps({
  class: { type: null, required: false, default: '' },
  variant: { type: null, required: false, default: 'default' },
});

</script>

<template>
  <div
    :class="
      cn(
        cardVariants({ intent: props.variant }),
        props.class,
      )
    "
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'CardComponent',
};
</script>
